import { routerStyxie } from '@/router/styxieBridge'
import { useLsaCommonStore } from '@/stores/lsa/common'

Styxie.Initializers.LsaAccounts = routerStyxie({
  actions: ['show'],
  hydrate: (props, pinia) => useLsaCommonStore(pinia).initialize(props)
})
